import { Format } from 'applicaiton/constants/scheduler';
import dayjs from 'dayjs';

export const getCalculatedFormattedDate = (
  currentDate: string,
  addDays: number,
) => {
  return dayjs(currentDate).set('day', addDays).format(Format.dateFormat);
};
